import Logo from "../Logo";
import React from "react";
import getTime from "../../helpers/getTime";
import useEvent from "../../hooks/useEvent";

const FooterHeader = () => {
  const event = useEvent();

  return (
    <>
      <Logo />
      <div className="mt-8">
        <div className="text-sm font-bold text-aqua">
          {event === "IADR"
            ? "IADR-SEA"
            : event === "SEAADE"
            ? "SEAADE"
            : "SEAADE-IADR-SEA"}{" "}
          {getTime().getFullYear()}
        </div>
        <div className="w-8/12 mt-4 text-xs text-gray-400">
          ©{getTime().getFullYear()} by{" "}
          {event === "IADR"
            ? "International Association of Dental Research - South East Asia Division (IADR-SEA)."
            : event === "SEAADE"
            ? "The South East Asia Association for Dental Education (SEAADE)."
            : "International Association of Dental Research - South East Asia Division (IADR-SEA) & The South East Asia Association for Dental Education (SEAADE)."}
        </div>
      </div>
    </>
  );
};

export default FooterHeader;
